import * as React from "react"
import { Action, IOWidget, mk_widget } from "widgets-for-react"
import { CMSState } from "../../../../cms/blocks/types.gen"
import { PublicSite_CustomPageData } from "../../../application.mod";

export interface SidebarItemProps {
  percentage?: number
  title?: string
  intro?: string
  image_url?: string
  image_id?: number
}

export type SidebarBlockProps<CustomBlockData, extra_images> = {
  title?: string
  link_text?: string
  link_url?: string
  blocks: Array<SidebarItemProps>
}

export type SidebarBlockStyle = Partial<{

}>


export function SideBarBlock<customBlockData, extra_images>(
  props: SidebarBlockProps<customBlockData, extra_images>,
  options?: {
    key?: string
  }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => {
        return <section className="block block--sidebar">
          <a className="block__link--sidebar" href={props.link_url}>
            <div className="block__inner">
              <header className="block__header">
                {props.title && (<h2 className="block__title typo--l">{props.title}</h2>)}
              </header>
              <div className="block__content">
                <ul className="block__cards cards">
                  {
                    props.blocks.map(block => <li className="card">
                      <article className="card__inner">
                        <header className="card__header">
                          {block.title && (<h3 className="card__title typo--xs">{block.title}</h3>)}
                          {block.percentage && (<p className="card__amount typo--3xl">{block.percentage}%</p>)}
                          {block.intro && (<p className="card__intro typo--4xs">{block.intro}</p>)}
                        </header>
                        <div className="card__visual">
                          {block.image_url && (<img width="70px" alt={`icon_${block.image_id}`} src={block.image_url} />)}
                        </div>
                      </article>
                    </li>)
                  }
                </ul>
              </div>
              <footer className="block__footer">
                {props.link_url && (<span className="link link--primary">{props.link_text ? props.link_text : props.link_url}</span>)}
              </footer>
            </div>
          </a>
        </section>
      }
    })
}
